<div class="MainBg MF_Central_Design">
  <div class="NewHeadOuter mb-0">
    <div class="SectionTopHeading_n" *ngIf="!IsMobile">Holdings</div>
    <div>
      <div class="SectionTopHeading_n" *ngIf="IsMobile">Portfolio Summary</div>
      <!-- <div class="TypoHead" *ngIf="IsMobile">As on 7th July 2024</div> -->
      <div class="TypoHead" *ngIf="IsMobile">
        As on {{ AllFundAsOnDateBinding | date : "d MMMM yyyy" }}
      </div>
    </div>
    <div class="mt-4 align-self-center UpdatePosi" *ngIf="IsMobile">
      <button class="CommonSubmitButton Button_n Btn_MfCentral" (click)="updateHoldingDetails()">
        Refresh Holdings
      </button>
    </div>
  </div>

  <div class="SummaryOuter bg-white p-3" *ngIf="IsAll && IsMobile">
    <div class="TopMost-1 pb-3">
      <div>
        <span class="SecondTitleCommon Value">
          {{ ClientName }}&nbsp;
          <span class="Value">{{ ClientPan }} &nbsp; &nbsp;</span>
        </span>
      </div>
    </div>
    <div class="TopMost-1 mb-2">
      <div>
        <span class="AlignIcn">
          Abs. retun:&nbsp;
          <span [ngClass]="AllFundAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'">{{ AllFundAbcReturnValue | number :
            "1.2-2" }}%</span>
        </span>
      </div>
      <div>
        <span class="AlignIcn">
          &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="AllFundXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">{{
            AllFundXIRRValue | number : "1.2-2" }}%</span>
        </span>
      </div>
    </div>
    <div class="TopMost-2">
      <div>
        <div class="SecondTitleCommon">Investment Value</div>
        <div class="Value">{{ AllFundPurchaseValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Current Value</div>
        <div class="Value">{{ AllFundCurrentValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Gain/Loss</div>
        <div class="Value">{{ AllFundGainLoss | number : "1.2-2" }}</div>
      </div>
    </div>
  </div>

  <div class="SummaryOuter bg-white p-3" *ngIf="IsJM && IsMobile">
    <div class="TopMost-1 pb-3">
      <div>
        <span class="SecondTitleCommon Value">
          {{ ClientName }}&nbsp;
          <span class="Value">{{ ClientPan }} &nbsp; &nbsp;</span>
        </span>
      </div>
    </div>
    <div class="TopMost-1 mb-2">
      <div>
        <span class="AlignIcn">
          Abs. retun:&nbsp;
          <span [ngClass]="JMAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'">{{ JMAbcReturnValue | number : "1.2-2"
            }}%</span>
        </span>
      </div>
      <div>
        <span class="AlignIcn">
          &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="JMXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">{{ JMXIRRValue | number
            : "1.2-2" }}%</span>
        </span>
      </div>
    </div>
    <div class="TopMost-2">
      <div>
        <div class="SecondTitleCommon">Investment Value</div>
        <div class="Value">{{ JMPurchaseValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Current Value</div>
        <div class="Value">{{ JMCurrentValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Gain/Loss</div>
        <div class="Value">{{ JMGainLoss | number : "1.2-2" }}</div>
      </div>
    </div>
  </div>

  <div class="SummaryOuter bg-white p-3" *ngIf="IsExternal && IsMobile">
    <div class="TopMost-1 pb-3">
      <div>
        <span class="SecondTitleCommon Value">
          {{ ClientName }}&nbsp;
          <span class="Value">{{ ClientPan }} &nbsp; &nbsp;</span>
        </span>
      </div>
    </div>
    <div class="TopMost-1 mb-2">
      <div>
        <span class="AlignIcn">
          Abs. retun:&nbsp;
          <span [ngClass]="HeldAwayAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'">{{ HeldAwayAbcReturnValue | number :
            "1.2-2" }}%</span>
        </span>
      </div>
      <div>
        <span class="AlignIcn">
          &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="HeldAwayXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">{{
            HeldAwayXIRRValue | number : "1.2-2" }}%</span>
        </span>
      </div>
    </div>
    <div class="TopMost-2">
      <div>
        <div class="SecondTitleCommon">Investment Value</div>
        <div class="Value">{{ HeldAwayPurchaseValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Current Value</div>
        <div class="Value">{{ HeldAwayCurrentValue | number : "1.2-2" }}</div>
      </div>
      <div>
        <div class="SecondTitleCommon">Gain/Loss</div>
        <div class="Value">{{ HeldAwayGainLoss | number : "1.2-2" }}</div>
      </div>
    </div>
  </div>

  <div class="DotTabs d-flex justify-content-between align-items-center" *ngIf="!IsMobile">
    <ul class="nav nav-tabs p-0">
      <li id="id_mf_client">
        <a class="active" data-toggle="tab" href="#All_Funds" (click)="resetCollapse()">Total AUM</a>
      </li>
      <li>
        <a data-toggle="tab" href="#With_JM" (click)="resetCollapse()">Incred Markets AUM</a>
      </li>
      <li>
        <a data-toggle="tab" href="#External_Funds" (click)="resetCollapse()">No Revenue AUM</a>
      </li>
    </ul>
    <div class="align-self-center UpdatePosi">
      <!-- <button class="CommonSubmitButton Button_n Btn_MfCentral" (click)="OnClickUpdate()">Update Holdings</button> -->
      <button class="CommonSubmitButton Button_n Btn_MfCentral" (click)="updateHoldingDetails()">
        Refresh Holdings
      </button>
    </div>
  </div>
  <div class="MainInnerFormWithoutFlex mt-0 bg-transparent" *ngIf="!IsMobile">
    <div class="tab-content UnderLineTabsContent bg-transparent">
      <div id="All_Funds" class="tab-pane fade Parent_Pane_BS_Clients show active">
        <div class="SummaryOuter bg-white p-3">
          <div class="Summary">
            <div>
              <div class="TypoHead">{{ ClientPan }}</div>
              <div class="TypoValue">{{ ClientName }}</div>
            </div>
            <div class="SummaryInner">
              <div>
                <div class="TypoHead">Invested Value</div>
                <div class="Value">
                  ₹ {{ AllFundPurchaseValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Current value</div>
                <div class="Value">
                  ₹ {{ AllFundCurrentValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Gain/Loss</div>
                <div class="Value">
                  ₹ {{ AllFundGainLoss | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Abs. Returns</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="
                    AllFundAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'
                  ">
                  {{ AllFundAbcReturnValue | number : "1.2-2" }}%
                </div>
              </div>
              <div>
                <div class="TypoHead">XIRR</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="AllFundXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">
                  {{ AllFundXIRRValue | number : "1.2-2" }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="DetailedSummary bg-white mt-3">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card" *ngFor="
                    let allfund of AllFundAllSchemeListDetails;
                    let i = index
                  ">
                  <div class="card-header pointer">
                    <div class="AccordionHeadSectionGrid">
                      <div class="AccordionHeadSectionGridColumn">
                        <div class="AccordionLogo">
                          <img src="../../assets/images/JM/MF_Central/{{
                              allfund.AmcCode
                            }}.svg" alt="" />
                        </div>
                        <div class="AccordionText">
                          <div class="TypoValue">{{ allfund.Folio }}</div>
                          <div class="TypoValue ClrBlack">
                            {{ allfund.schemeName }}
                          </div>
                        </div>
                      </div>
                      <div class="AccordionInner">
                        <div class="">
                          <!-- <div class="AccordionText"> -->
                          <div class="TypoHead">Invested value</div>
                          <div class="Value">
                            ₹ {{ allfund.InvestedValue | number : "1.2-2" }}
                          </div>
                          <!-- </div> -->
                        </div>
                        <div class="">
                          <!-- <div class="AccordionText"> -->
                          <div class="TypoHead">Current Value</div>
                          <div class="Value">
                            ₹ {{ allfund.CurrentValue | number : "1.2-2" }}
                          </div>
                          <!-- </div> -->
                        </div>
                        <div class="">
                          <!-- <div class="AccordionText"> -->
                          <div class="TypoHead">Gain/Loss</div>
                          <div class="Value">
                            ₹ {{ allfund.GainLoss | number : "1.2-2" }}
                          </div>
                          <!-- </div> -->
                        </div>
                        <div class="">
                          <!-- <div class="AccordionText"> -->
                          <div class="TypoHead">Abs. Returns</div>
                          <div class="AccordionGreenNumValue" [ngClass]="
                              allfund.AbsReturn < 0 ? 'ColorRed' : 'ColorGreen'
                            ">
                            {{ allfund.AbsReturn | number : "1.2-2" }}%
                          </div>
                          <!-- </div> -->
                        </div>
                        <div class="d-flex">
                          <!-- <div class="AccordionText"> -->
                          <div>
                            <div class="TypoHead">XIRR</div>
                            <div class="AccordionGreenNumValue">
                              {{ allfund.XIRR | number : "1.2-2" }}%
                            </div>
                          </div>
                          <!-- </div> -->
                          <div class="d-flex align-items-center arrowicon">
                            <span class="collapseIcon position-relative" style="cursor: pointer" (click)="
                              OpenMenu(
                                allfund.pekrn,
                                allfund.BSCSchemeCode,
                                allfund.BSEAMCCode,
                                allfund.Folio,
                                allfund.AmcCode,
                                allfund.FctSchemeCode,
                                allfund.SchemeType,
                                allfund.CLASSCODE,
                                allfund.schemeName,
                                'Allfund'
                              )
                            "><i class="fa fa-bars menuIcon" aria-hidden="true"></i></span>
                            <img class="arrow-icon" [ngClass]="{ collapsed: isCollapsed(i) }" (click)="
                                onArrowClick(
                                  i,
                                  allfund.FctSchemeCode,
                                  allfund.Folio,
                                  allfund.ISIN
                                )
                              " src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg" alt="Toggle Collapse" />
                          </div>
                        </div>
                      </div>

                      <!-- <div class="d-flex align-items-center">
                        <span
                          class="collapseIcon position-relative"
                          style="cursor: pointer"
                          (click)="
                            OpenMenu(
                              allfund.BSCSchemeCode,
                              allfund.BSEAMCCode,
                              allfund.Folio,
                              allfund.AmcCode,
                              allfund.FctSchemeCode,
                              allfund.SchemeType,
                              allfund.CLASSCODE,
                              allfund.schemeName,
                              'Allfund'
                            )
                          "
                          ><i class="fa fa-bars menuIcon" aria-hidden="true"></i
                        ></span>

                        <img
                          class="arrow-icon"
                          [ngClass]="{ collapsed: isCollapsed(i) }"
                          (click)="
                            onArrowClick(
                              i,
                              allfund.FctSchemeCode,
                              allfund.Folio,
                              allfund.ISIN
                            )
                          "
                          src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg"
                          alt="Toggle Collapse"
                        />
                      </div> -->
                    </div>
                  </div>
                  <div class="card-body faq" *ngIf="isCollapsed(i)">
                    <div class="AccordionHeadSectionGrid" *ngFor="let trxnDet of TrxnDetailsDataList">
                      <div class="AccordionHeadSectionGridColumn"></div>
                      <div class="AccordionInnerContent">
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Trade Date</div>
                            <div class="Value">
                              {{ trxnDet.TrxnDate | date : "dd/MM/yyyy" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Transaction Type</div>
                            <div class="Value">{{ trxnDet.TrxnTypeFlag }}</div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Units</div>
                            <div class="Value">
                              {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">NAV</div>
                            <div class="Value">
                              ₹ {{ trxnDet.NAV | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Amount</div>
                            <div class="Value">
                              ₹ {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="With_JM" class="tab-pane fade Parent_Pane_BS_Clients">
        <div class="SummaryOuter bg-white p-3">
          <div class="Summary">
            <div>
              <div class="TypoHead">{{ ClientPan }}</div>
              <div class="TypoValue">{{ ClientName }}</div>
            </div>
            <div class="SummaryInner">
              <div>
                <div class="TypoHead">Invested Value</div>
                <div class="Value">
                  ₹ {{ JMPurchaseValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Current value</div>
                <div class="Value">
                  ₹ {{ JMCurrentValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Gain/Loss</div>
                <div class="Value">₹ {{ JMGainLoss | number : "1.2-2" }}</div>
              </div>
              <div>
                <div class="TypoHead">Abs. Returns</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="JMAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'">
                  {{ JMAbcReturnValue | number : "1.2-2" }}%
                </div>
              </div>
              <div>
                <div class="TypoHead">XIRR</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="JMXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">
                  {{ JMXIRRValue | number : "1.2-2" }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="DetailedSummary bg-white mt-3">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card" *ngFor="let JMRecomm of JMAllSchemeListDetails; let i = index">
                  <div class="card-header pointer">
                    <div class="AccordionHeadSectionGrid">
                      <div class="AccordionHeadSectionGridColumn">
                        <div class="AccordionLogo">
                          <img src="../../assets/images/JM/MF_Central/{{
                              JMRecomm.AmcCode
                            }}.svg" alt="" />
                        </div>
                        <div class="AccordionText">
                          <div class="TypoValue">{{ JMRecomm.Folio }}</div>
                          <div class="TypoValue ClrBlack">
                            {{ JMRecomm.schemeName }}
                          </div>
                        </div>
                      </div>
                      <div class="AccordionInner">
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Invested value</div>
                            <div class="Value">
                              ₹ {{ JMRecomm.InvestedValue | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Current Value</div>
                            <div class="Value">
                              ₹ {{ JMRecomm.CurrentValue | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Gain/Loss</div>
                            <div class="Value">
                              ₹ {{ JMRecomm.GainLoss | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Abs. Returns</div>
                            <div class="AccordionGreenNumValue" [ngClass]="
                                JMRecomm.AbsReturn < 0
                                  ? 'ColorRed'
                                  : 'ColorGreen'
                              ">
                              {{ JMRecomm.AbsReturn | number : "1.2-2" }}%
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <!-- <div class="AccordionText"> -->
                          <div>
                            <div class="TypoHead">XIRR</div>
                            <div class="AccordionGreenNumValue">
                              {{ JMRecomm.XIRR | number : "1.2-2" }}%
                            </div>
                          </div>
                          <!-- </div> -->
                          <div class="d-flex align-items-center arrowicon">
                            <span class="collapseIcon position-relative" style="cursor: pointer" (click)="
                              OpenMenu(
                                JMRecomm.pekrn,
                                JMRecomm.BSCSchemeCode,
                                JMRecomm.BSEAMCCode,
                                JMRecomm.Folio,
                                JMRecomm.AmcCode,
                                JMRecomm.FctSchemeCode,
                                JMRecomm.SchemeType,
                                JMRecomm.CLASSCODE,
                                JMRecomm.schemeName,
                                'JMRecomm'
                              )
                            "><i class="fa fa-bars menuIcon" aria-hidden="true"></i></span>
                            <img class="arrow-icon" [ngClass]="{ collapsed: isCollapsed(i) }" (click)="
                                onArrowClick(
                                  i,
                                  JMRecomm.FctSchemeCode,
                                  JMRecomm.Folio,
                                  JMRecomm.ISIN
                                )
                              " src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg" alt="Toggle Collapse" />
                          </div>
                        </div>
                      </div>
                      <!-- <div class="d-flex align-items-center">
                        <span
                          class="collapseIcon position-relative"
                          style="cursor: pointer"
                          (click)="
                            OpenMenu(
                              JMRecomm.BSCSchemeCode,
                              JMRecomm.BSEAMCCode,
                              JMRecomm.Folio,
                              JMRecomm.AmcCode,
                              JMRecomm.FctSchemeCode,
                              JMRecomm.SchemeType,
                              JMRecomm.CLASSCODE,
                              JMRecomm.schemeName,
                              'JMRecomm'
                            )
                          "
                          ><i class="fa fa-bars menuIcon" aria-hidden="true"></i
                        ></span>

                        <img
                          class="arrow-icon"
                          [ngClass]="{ collapsed: isCollapsed(i) }"
                          (click)="
                            onArrowClick(
                              i,
                              JMRecomm.FctSchemeCode,
                              JMRecomm.Folio,
                              JMRecomm.ISIN
                            )
                          "
                          src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg"
                          alt="Toggle Collapse"
                        />
                      </div> -->
                    </div>
                  </div>
                  <div class="card-body faq" *ngIf="isCollapsed(i)">
                    <div class="AccordionHeadSectionGrid" *ngFor="let trxnDet of TrxnDetailsDataList">
                      <div class="AccordionHeadSectionGridColumn"></div>
                      <div class="AccordionInnerContent">
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Trade Date</div>
                            <div class="Value">
                              {{ trxnDet.TrxnDate | date : "dd/MM/yyyy" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Transaction Type</div>
                            <div class="Value">{{ trxnDet.TrxnTypeFlag }}</div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Units</div>
                            <div class="Value">
                              {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">NAV</div>
                            <div class="Value">
                              ₹ {{ trxnDet.NAV | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Amount</div>
                            <div class="Value">
                              ₹ {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="External_Funds" class="tab-pane fade Parent_Pane_BS_Clients">
        <div class="SummaryOuter bg-white p-3">
          <div class="Summary">
            <div>
              <div class="TypoHead">{{ ClientPan }}</div>
              <div class="TypoValue">{{ ClientName }}</div>
            </div>
            <div class="SummaryInner">
              <div>
                <div class="TypoHead">Invested Value</div>
                <div class="Value">
                  ₹ {{ HeldAwayPurchaseValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Current value</div>
                <div class="Value">
                  ₹ {{ HeldAwayCurrentValue | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Gain/Loss</div>
                <div class="Value">
                  ₹ {{ HeldAwayGainLoss | number : "1.2-2" }}
                </div>
              </div>
              <div>
                <div class="TypoHead">Abs. Returns</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="
                    HeldAwayAbcReturnValue < 0 ? 'ColorRed' : 'ColorGreen'
                  ">
                  {{ HeldAwayAbcReturnValue | number : "1.2-2" }}%
                </div>
              </div>
              <div>
                <div class="TypoHead">XIRR</div>
                <div class="Value AccordionGreenNumValue" [ngClass]="HeldAwayXIRRValue < 0 ? 'ColorRed' : 'ColorGreen'">
                  {{ HeldAwayXIRRValue | number : "1.2-2" }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="DetailedSummary bg-white mt-3">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card" *ngFor="
                    let HeldAway of HeldAwayAllSchemeListDetails;
                    let i = index
                  ">
                  <div class="card-header pointer">
                    <div style="position:relative; left:85%">
                      <span class="align-self:end">Updated Date :
                        {{HeldAway.PortfolioUpdatedDate.toString().substring(0,10)}}</span>
                    </div>
                    <div class="AccordionHeadSectionGrid">
                      <div class="AccordionHeadSectionGridColumn">
                        <div class="AccordionLogo">
                          <img src="../../assets/images/JM/MF_Central/{{
                              HeldAway.AmcCode
                            }}.svg" alt="" />
                        </div>
                        <div class="AccordionText">
                          <div class="TypoValue">{{ HeldAway.Folio }}</div>
                          <div class="TypoValue ClrBlack">
                            {{ HeldAway.schemeName }}
                          </div>
                        </div>
                      </div>
                      <div class="AccordionInner">
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Invested value</div>
                            <div class="Value">
                              ₹ {{ HeldAway.InvestedValue | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Current Value</div>
                            <div class="Value">
                              ₹ {{ HeldAway.CurrentValue | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Gain/Loss</div>
                            <div class="Value" >
                              ₹ {{ HeldAway.GainLoss | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="">
                          <div class="AccordionText">
                            <div class="TypoHead">Abs. Returns</div>
                            <div class="AccordionGreenNumValue" [ngClass]="
                                HeldAway.AbsReturn < 0
                                  ? 'ColorRed'
                                  : 'ColorGreen'
                              ">
                              {{ HeldAway.AbsReturn | number : "1.2-2" }}%
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <!-- <div class="AccordionText"> -->
                          <div>
                            <div class="TypoHead">XIRR</div>
                            <div class="AccordionGreenNumValue">
                              {{ HeldAway.XIRR | number : "1.2-2" }}%
                            </div>
                          </div>
                          <!-- </div> -->
                          <div class="d-flex align-items-center arrowicon">
                            <span class="collapseIcon position-relative" style="cursor: pointer" (click)="
                              OpenMenu(
                                HeldAway.pekrn,
                                HeldAway.BSCSchemeCode,
                                HeldAway.BSEAMCCode,
                                HeldAway.Folio,
                                HeldAway.AmcCode,
                                HeldAway.FctSchemeCode,
                                HeldAway.SchemeType,
                                HeldAway.CLASSCODE,
                                HeldAway.schemeName,
                                'HeldAway'
                              )
                            "><i class="fa fa-bars menuIcon" aria-hidden="true"></i></span>
                            <img class="arrow-icon" [ngClass]="{ collapsed: isCollapsed(i) }" (click)="
                                onArrowClick(
                                  i,
                                  HeldAway.FctSchemeCode,
                                  HeldAway.Folio,
                                  HeldAway.ISIN
                                )
                              " src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg" alt="Toggle Collapse" />
                          </div>
                        </div>
                      </div>

                      <!-- <div class="d-flex align-items-center">
                        <span
                          class="collapseIcon position-relative"
                          style="cursor: pointer"
                          (click)="
                            OpenMenu(
                              HeldAway.BSCSchemeCode,
                              HeldAway.BSEAMCCode,
                              HeldAway.Folio,
                              HeldAway.AmcCode,
                              HeldAway.FctSchemeCode,
                              HeldAway.SchemeType,
                              HeldAway.CLASSCODE,
                              HeldAway.schemeName,
                              'HeldAway'
                            )
                          "
                          ><i class="fa fa-bars menuIcon" aria-hidden="true"></i
                        ></span>

                        <img
                          class="arrow-icon"
                          [ngClass]="{ collapsed: isCollapsed(i) }"
                          (click)="
                            onArrowClick(
                              i,
                              HeldAway.FctSchemeCode,
                              HeldAway.Folio,
                              HeldAway.ISIN
                            )
                          "
                          src="../../assets/images/JM/MF_Central/DropDownDownArrow.svg"
                          alt="Toggle Collapse"
                        />
                      </div> -->
                    </div>

                  </div>
                  <div class="card-body faq" *ngIf="isCollapsed(i)">
                    <div class="AccordionHeadSectionGrid" *ngFor="let trxnDet of TrxnDetailsDataList">
                      <div class="AccordionHeadSectionGridColumn"></div>
                      <div class="AccordionInnerContent">
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Trade Date</div>
                            <div class="Value">
                              {{ trxnDet.TrxnDate | date : "dd/MM/yyyy" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Transaction Type</div>
                            <div class="Value">{{ trxnDet.TrxnTypeFlag }}</div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Units</div>
                            <div class="Value">
                              {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">NAV</div>
                            <div class="Value">
                              ₹ {{ trxnDet.NAV | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="BorderBottom">
                          <div class="AccordionText">
                            <div class="TypoHead">Amount</div>
                            <div class="Value">
                              ₹ {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- for mobile-->
  <div class="SectionTopHeading_n px-3 mt-4" *ngIf="IsMobile">Holdings</div>
  <div class="DotTabs d-flex justify-content-between align-items-center" *ngIf="IsMobile">
    <ul class="nav nav-tabs p-0">
      <li (click)="onChangeTab('ALL')" id="id_mf_client">
        <a class="active" data-toggle="tab" href="#All_Funds" (click)="resetCollapse()">Total AUM</a>
      </li>
      <li (click)="onChangeTab('JM')">
        <a data-toggle="tab" href="#With_JM" (click)="resetCollapse()">Incred Markets AUM</a>
      </li>
      <li (click)="onChangeTab('External')">
        <a data-toggle="tab" href="#External_Funds" (click)="resetCollapse()">No Revenue AUM</a>
      </li>
    </ul>
  </div>
  <div class="MainInnerFormWithoutFlex mt-0 bg-transparent" *ngIf="IsMobile">
    <div class="tab-content UnderLineTabsContent bg-transparent">
      <div id="All_Funds" class="tab-pane fade Parent_Pane_BS_Clients show active">
        <div class="DetailedSummary bg-white">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card">
                  <div class="cardInner" *ngFor="
                      let allfund of AllFundAllSchemeListDetails;
                      let i = index
                    ">
                    <div class="card-header pointer">
                      <div class="">
                        <div class="AccordionHeadSectionGridColumn pb-3">
                          <!-- <div class="logotext"> -->
                          <div class="AccordionLogo" (click)="
                              OpenMenu(
                                allfund.pekrn,
                                allfund.BSCSchemeCode,
                                allfund.BSEAMCCode,
                                allfund.Folio,
                                allfund.AmcCode,
                                allfund.FctSchemeCode,
                                allfund.SchemeType,
                                allfund.CLASSCODE,
                                allfund.schemeName,
                                'Allfund'
                              )
                            ">
                            <img src="../../assets/images/JM/MF_Central/{{
                                allfund.AmcCode
                              }}.svg" alt="" />
                          </div>
                          <div class="AccordionText">
                            <!-- <div class="TypoValue">1042551793</div> -->
                            <div class="TypoValue ClrBlack">
                              {{ allfund.schemeName }}
                            </div>
                            <div class="TopMost-1">
                              <div>
                                <span class="AlignIcn">
                                  Abs. retun:&nbsp;
                                  <span [ngClass]="
                                      allfund.AbsReturn < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">
                                    {{
                                    allfund.AbsReturn | number : "1.2-2"
                                    }}%</span>
                                </span>
                              </div>
                              <div>
                                <span class="AlignIcn">
                                  &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="
                                      allfund.XIRR < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">
                                    {{ allfund.XIRR | number : "1.2-2" }}%</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-2">
                          <div>
                            <div class="SecondTitleCommon">
                              Investment Value
                            </div>
                            <div class="Value">
                              {{ allfund.InvestedValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Current Value</div>
                            <div class="Value">
                              {{ allfund.CurrentValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Gain/Loss</div>
                            <div class="Value">
                              {{ allfund.GainLoss | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-3">
                          <div>
                            <span class="AlignIcn">
                              Folio no.&nbsp;
                              <span class="ClrBlue_n">{{ allfund.Folio }}</span>
                            </span>
                          </div>
                          <div>
                            <span class="arrow-icon-Mob AlignIcn ClrRed_n" [ngClass]="{ collapsed: isCollapsed(i) }"
                              (click)="
                                onArrowClick(
                                  i,
                                  allfund.FctSchemeCode,
                                  allfund.Folio,
                                  allfund.ISIN
                                )
                              " alt="Toggle Collapse">{{ isShowMoreLess }}</span>
                          </div>
                        </div>
                        <div class="card-body faq" *ngIf="isCollapsed(i)">
                          <div *ngFor="let trxnDet of TrxnDetailsDataList">
                            <div class="TopMost-1 pb-3">
                              <div>
                                <span class="SecondTitleCommon">
                                  Trade Date:&nbsp;
                                  <span class="Value">{{
                                    trxnDet.TrxnDate | date : "dd/MM/yyyy"
                                    }}
                                    &nbsp; &nbsp;</span>
                                </span>
                              </div>
                              <div>
                                <span class="SecondTitleCommon">
                                  <i class="fa fa-circle"></i>
                                  &nbsp; &nbsp;Transaction Type: &nbsp;<span class="Value">
                                    {{ trxnDet.TrxnTypeFlag }}</span>
                                </span>
                              </div>
                            </div>
                            <div class="TopMost-4">
                              <div>
                                <div class="SecondTitleCommon">Units</div>
                                <div class="Value">
                                  {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">NAV</div>
                                <div class="Value">
                                  &#8377; {{ trxnDet.NAV | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">Amount</div>
                                <div class="Value">
                                  &#8377;
                                  {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="With_JM" class="tab-pane fade Parent_Pane_BS_Clients">
        <div class="DetailedSummary bg-white">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card">
                  <div class="cardInner" *ngFor="
                      let JMRecomm of JMAllSchemeListDetails;
                      let i = index
                    ">
                    <div class="card-header pointer">
                      <div class="">
                        <div class="AccordionHeadSectionGridColumn pb-3">
                          <div class="AccordionLogo" (click)="
                              OpenMenu(
                                JMRecomm.pekrn,
                                JMRecomm.BSCSchemeCode,
                                JMRecomm.BSEAMCCode,
                                JMRecomm.Folio,
                                JMRecomm.AmcCode,
                                JMRecomm.FctSchemeCode,
                                JMRecomm.SchemeType,
                                JMRecomm.CLASSCODE,
                                JMRecomm.schemeName,
                                'JMRecomm'
                              )
                            ">
                            <img src="../../assets/images/JM/MF_Central/{{
                                JMRecomm.AmcCode
                              }}.svg" alt="" />
                          </div>
                          <div class="AccordionText">
                            <div class="TypoValue ClrBlack">
                              {{ JMRecomm.schemeName }}
                            </div>
                            <div class="TopMost-1">
                              <div>
                                <span class="AlignIcn">
                                  Abs. retun:&nbsp;
                                  <span [ngClass]="
                                      JMRecomm.AbsReturn < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">
                                    {{
                                    JMRecomm.AbsReturn | number : "1.2-2"
                                    }}%</span>
                                </span>
                              </div>
                              <div>
                                <span class="AlignIcn">
                                  &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="
                                      JMRecomm.XIRR < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">
                                    {{
                                    JMRecomm.XIRR | number : "1.2-2"
                                    }}%</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-2">
                          <div>
                            <div class="SecondTitleCommon">
                              Investment Value
                            </div>
                            <div class="Value">
                              {{ JMRecomm.InvestedValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Current Value</div>
                            <div class="Value">
                              {{ JMRecomm.CurrentValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Gain/Loss</div>
                            <div class="Value">
                              {{ JMRecomm.GainLoss | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-3">
                          <div>
                            <span class="AlignIcn">
                              Folio no.&nbsp;
                              <span class="ClrBlue_n">{{
                                JMRecomm.Folio
                                }}</span>
                            </span>
                          </div>
                          <div>
                            <span class="arrow-icon-Mob AlignIcn ClrRed_n" [ngClass]="{ collapsed: isCollapsed(i) }"
                              (click)="
                                onArrowClick(
                                  i,
                                  JMRecomm.FctSchemeCode,
                                  JMRecomm.Folio,
                                  JMRecomm.ISIN
                                )
                              " alt="Toggle Collapse">{{ isShowMoreLess }}</span>
                          </div>
                        </div>
                        <div class="card-body faq" *ngIf="isCollapsed(i)">
                          <div *ngFor="let trxnDet of TrxnDetailsDataList">
                            <div class="TopMost-1 pb-3">
                              <div>
                                <span class="SecondTitleCommon">
                                  Trade Date:&nbsp;
                                  <span class="Value">{{
                                    trxnDet.TrxnDate | date : "dd/MM/yyyy"
                                    }}
                                    &nbsp; &nbsp;</span>
                                </span>
                              </div>
                              <div>
                                <span class="SecondTitleCommon">
                                  <i class="fa fa-circle"></i>
                                  &nbsp; &nbsp;Transaction Type: &nbsp;<span class="Value">{{ trxnDet.TrxnTypeFlag
                                    }}</span>
                                </span>
                              </div>
                            </div>
                            <div class="TopMost-4">
                              <div>
                                <div class="SecondTitleCommon">Units</div>
                                <div class="Value">
                                  {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">NAV</div>
                                <div class="Value">
                                  &#8377; {{ trxnDet.NAV | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">Amount</div>
                                <div class="Value">
                                  &#8377;
                                  {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="External_Funds" class="tab-pane fade Parent_Pane_BS_Clients">
        <div class="DetailedSummary bg-white">
          <div class="DetailedInner">
            <div class="">
              <div id="accordion" class="accordion">
                <div class="card">
                  <div class="cardInner" *ngFor="
                      let HeldAway of HeldAwayAllSchemeListDetails;
                      let i = index
                    ">
                    <div class="card-header pointer">
                      <div class="">
                        <div class="AccordionHeadSectionGridColumn pb-3">
                          <div class="AccordionLogo" (click)="
                              OpenMenu(
                                HeldAway.pekrn,
                                HeldAway.BSCSchemeCode,
                                HeldAway.BSEAMCCode,
                                HeldAway.Folio,
                                HeldAway.AmcCode,
                                HeldAway.FctSchemeCode,
                                HeldAway.SchemeType,
                                HeldAway.CLASSCODE,
                                HeldAway.schemeName,
                                'HeldAway'
                              )
                            ">
                            <img src="../../assets/images/JM/MF_Central/{{
                                HeldAway.AmcCode
                              }}.svg" alt="" />
                          </div>
                          <div class="AccordionText">
                            <div class="TypoValue ClrBlack">
                              {{ HeldAway.schemeName }}
                            </div>
                            <div class="TopMost-1">
                              <div>
                                <span class="AlignIcn">
                                  Abs. retun:&nbsp;
                                  <span [ngClass]="
                                      HeldAway.AbsReturn < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">{{
                                    HeldAway.AbsReturn | number : "1.2-2"
                                    }}%</span>
                                </span>
                              </div>
                              <div>
                                <span class="AlignIcn">
                                  &nbsp; &nbsp;XIRR: &nbsp;<span [ngClass]="
                                      HeldAway.XIRR < 0
                                        ? 'ColorRed'
                                        : 'ColorGreen'
                                    ">{{
                                    HeldAway.XIRR | number : "1.2-2"
                                    }}%</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-2">
                          <div>
                            <div class="SecondTitleCommon">
                              Investment Value
                            </div>
                            <div class="Value">
                              {{ HeldAway.InvestedValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Current Value</div>
                            <div class="Value">
                              {{ HeldAway.CurrentValue | number : "1.2-2" }}
                            </div>
                          </div>
                          <div>
                            <div class="SecondTitleCommon">Gain/Loss</div>
                            <div class="Value">
                              {{ HeldAway.GainLoss | number : "1.2-2" }}
                            </div>
                          </div>
                        </div>
                        <div class="TopMost-3">
                          <div>
                            <span class="AlignIcn">
                              Folio no.&nbsp;
                              <span class="ClrBlue_n">{{
                                HeldAway.Folio
                                }}</span>
                            </span>
                          </div>
                          <div>
                            <span class="arrow-icon-Mob AlignIcn ClrRed_n" [ngClass]="{ collapsed: isCollapsed(i) }"
                              (click)="
                                onArrowClick(
                                  i,
                                  HeldAway.FctSchemeCode,
                                  HeldAway.Folio,
                                  HeldAway.ISIN
                                )
                              " alt="Toggle Collapse">{{ isShowMoreLess }}</span>
                          </div>
                        </div>
                        <div class="card-body faq" *ngIf="isCollapsed(i)">
                          <div *ngFor="let trxnDet of TrxnDetailsDataList">
                            <div class="TopMost-1 pb-3">
                              <div>
                                <span class="SecondTitleCommon">
                                  Trade Date:&nbsp;
                                  <span class="Value">{{
                                    trxnDet.TrxnDate | date : "dd/MM/yyyy"
                                    }}
                                    &nbsp; &nbsp;</span>
                                </span>
                              </div>
                              <div>
                                <span class="SecondTitleCommon">
                                  <i class="fa fa-circle"></i>
                                  &nbsp; &nbsp;Transaction Type: &nbsp;<span class="Value">{{ trxnDet.TrxnTypeFlag
                                    }}</span>
                                </span>
                              </div>
                            </div>
                            <div class="TopMost-4">
                              <div>
                                <div class="SecondTitleCommon">Units</div>
                                <div class="Value">
                                  {{ trxnDet.TrxnUnits | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">NAV</div>
                                <div class="Value">
                                  &#8377; {{ trxnDet.NAV | number : "1.2-2" }}
                                </div>
                              </div>
                              <div>
                                <div class="SecondTitleCommon">Amount</div>
                                <div class="Value">
                                  &#8377;
                                  {{ trxnDet.TrxnAmount | number : "1.2-2" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- for mobile-->

      <div class="MainInnerFormWithoutFlex"></div>
    </div>
  </div>

  <!-- Modals Starts Here-->
  <div class="modal" id="TrackPopUp" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody pb-1">
          <div class="d-flex justify-content-between">
            <div class="HeadIcon">
              <img src="../../assets/images/JM/MF_Central/Modal_Icon.svg" alt="" />
            </div>
            <button type="button" class="close float-right" data-dismiss="modal" (click)="GoToDashboard()">
              <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt="" />
            </button>
          </div>
          <div class="TrackText my-3">
            Track your mutual fund investments in one place
          </div>
          <div class="InfoText">
            <div class="d-flex align-self-center">
              <img src="../../assets/images/JM/MF_Central/Checked.svg" alt="" width="20px" class="mr-2" />
              <span>Get detailed insights on your overall portfolio at one
                click.</span>
            </div>
            <div class="d-flex align-self-center mt-3">
              <img src="../../assets/images/JM/MF_Central/Checked.svg" alt="" width="20px" class="mr-2" />
              <span>Get updated holdings by simple OTP verification.</span>
            </div>
          </div>
          <div class="InfoText ClrBlack mt-5">
            Phone number(s) linked to your MF investments With Incred Markets can be<br />
            selected here.<br />
            Number(s) linked : {{ MaskingMobileNo }}.<br />
            In case you wish to add a new phone number
            <span style="color: red" (click)="EditMobile()">Click Here</span>
          </div>
          <div class="Note mt-4">
            Folios associated with the mentioned mobile number will only be fetched and in case different mobile number
            is updated in folio number then you need to manually enter the mobile number to fetch other folio details
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0 New_Modalfooter">
          <button type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0" (click)="OpenMobModal()">
            Get Started
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="UpdateMobilePopUp" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody pb-1">
          <div class="d-flex justify-content-between">
            <div class="HeadIcon">
              <img src="../../assets/images/JM/MF_Central/UpdateMob.svg" alt="" />
            </div>
            <button type="button" class="close float-right" data-dismiss="modal" (click)="EditMobileModalClosed()">
              <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt="" />
            </button>
          </div>
          <div class="TrackText my-3">Update Mobile Number</div>
          <div class="InfoText ClrBlack">
            Update Mobile Number will only be used to track external mutual fund
            investments.
          </div>

          <div class="DropdownSection">
            <div class="has-float-label">
              <select id="SelectUpdateMobile" formControlName="UpdateMob" maxlength="10" minlength="10" [ngClass]="{
                  'is-invalid': UpdateMobFormSubmit && r['UpdateMob'].errors
                }" (keypress)="ValidatePattern('Number', $event)"
                class="form-control CommonSelectBox TbxMarginBtm SelectUpdateMobile numonly"
                data-placeholder="Enter Mobile Number">
                <option value="" selected disabled>Enter Mobile Number</option>
                <option *ngFor="let data of SelectedMobileNumbers" [value]="data.OrignalValue">
                  {{ data.MaskValue }}
                </option>
              </select>
              <!-- <label>Enter Mobile Number</label> -->
              <div *ngIf="UpdateMobFormSubmit && r['UpdateMob'].errors" class="invalid-feedback">
                <div *ngIf="r['UpdateMob'].errors.required" class="Label14 OrangeClr">
                  Mobile number is required
                </div>
                <div *ngIf="r['UpdateMob'].errors.pattern" class="Label14 OrangeClr">
                  Please enter valid Mobile number.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0 New_Modalfooter">
          <button type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0" (click)="OnSubmitUpdateMobile()">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="AlertPopUp" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody pb-1">
          <div class="d-flex justify-content-between">
            <div class="HeadIcon">
              <img src="../../assets/images/JM/MF_Central/Alert.svg" alt="" width="45px" />
            </div>
            <button type="button" class="close float-right" data-dismiss="modal">
              <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt=""
                (click)="closePopup()" />
            </button>
          </div>
          <div class="TrackText my-3">Alert</div>
          <div class="InfoText ClrBlack" id="ShowAlertModalContentMsg"></div>
        </div>
        <div class="modal-footer justify-content-center border-0 New_Modalfooter">
          <button type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0" (click)="closePopup()">
            Okay
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="AlertPopUpMFCentral" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody pb-1">
          <div class="d-flex justify-content-between">
            <div class="HeadIcon">
              <img src="../../assets/images/JM/MF_Central/Alert.svg" alt="" width="45px" />
            </div>
            <button type="button" class="close float-right" data-dismiss="modal">
              <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt=""
                (click)="GoToDashboard()" />
            </button>
          </div>
          <div class="TrackText my-3">Alert</div>
          <div class="InfoText ClrBlack" id="AlertModalContentMsg"></div>
        </div>
        <div class="modal-footer justify-content-center border-0 New_Modalfooter">
          <button type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0" (click)="GoToDashboard()">
            Okay
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="OTPPopUp" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody pb-1">
          <div class="d-flex justify-content-between">
            <div class="HeadIcon">
              <img src="../../assets/images/JM/MF_Central/UpdateMob.svg" alt="" />
            </div>
            <button type="button" class="close float-right" data-dismiss="modal" (click)="OtpModalClosed()">
              <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt="" />
            </button>
          </div>
          <div class="TrackText my-3">OTP Verification</div>
          <div class="InfoText ClrBlack">
            You will Receive on OTP from MF Central (SEBI Regulated Entity) On
            <b>{{ MobileNo }}</b>
          </div>
          <form class="mt-4" [ngClass]="!IsMobile ? 'mb-5' : 'mb-3 mx-4'">
            <div class="InfoText mt-2" style="color: red" *ngIf="IsVerify">
              Incorrect OTP please enter correct OTP.
            </div>
            <div class="my-4">
              <ng-otp-input id="OTPBox" #ngOtpInput [config]="{
                  length: 6,
                  inputClass: 'OTPBox',
                  allowNumbersOnly: true,
                  disableAutoFocus: false,
                  inputStyles: {
                    'text-security': 'disc',
                    '-webkit-text-security': 'disc',
                    '-moz-text-security': 'disc'
                  },
                  isNumberInput: true
                }" (onInputChange)="onOtpChange($event)" inputmode="numeric" pattern="[0-9]*"
                (keypress)="keypressnumber($event, 'OTP')">
              </ng-otp-input>
            </div>
          </form>
          <div class="Resend">
            Didn't receive OTP?
            <a id="ResendBtn" class="RedClr CursorPointer" (click)="ResendOTP()">
              <strong>Resend</strong>
            </a>
            in <span id="Time"></span><span> &nbsp;sec</span>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-0 New_Modalfooter">
          <button id="Verify" type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0"
            [disabled]="!OTPForm.valid" (click)="OnVerify()">
            Verify
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Modals Ends Here-->

  <!-- <div class="modal" id="AlertModalMFCentral" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Important Message</div>
                <div id="AlertModalContentMsg" class="modal-body AlertModalBody"></div>
                <div class="modal-footer AlertModalFooter">
                    <button type="button" data-dismiss="modal" class="CursorPointer"
                        (click)="GoToDashboard()">Okay</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal" id="ShowAlertModal" appDisabledRightClick>
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content AlertModalContentCls">
                <div class="modal-header AlertModalHeader">Important Message</div>
                <div id="ShowAlertModalContentMsg" class="modal-body AlertModalBody"></div>
                <div class="modal-footer AlertModalFooter">
                    <button type="button" data-dismiss="modal" class="CursorPointer">Okay</button>
                </div>
            </div>
        </div>
    </div> -->

  <div class="modal" id="MobileNoSelection_Modal" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <form autocomplete="off" autocomplete="off" [formGroup]="GetMobileForm">
          <div class="modal-body New_ModalBody pb-1">
            <div class="d-flex justify-content-between">
              <div class="HeadIcon">
                <img src="../../assets/images/JM/MF_Central/UpdateMob.svg" alt="" />
              </div>
              <button type="button" class="close float-right" data-dismiss="modal">
                <img src="../../assets/images/JM/MF_Central/Close.svg" class="CloseIcon" width="32px" alt="" />
              </button>
            </div>
            <div class="TrackText my-3">Select Mobile Number and Email</div>
            <!-- <div class="InfoText ClrBlack">
                        Update Mobile Number will only be used to track external mutual fund investments.
                    </div> -->

            <div class="DropdownSection">
              <div class="has-float-label">
                <select id="SelectMobile" formControlName="MobileNo" placeholder="Select Mobile No and Email" [ngClass]="{
                    'is-invalid': GetMobileFormSubmit && MobForm.MobileNo.errors
                  }" class="form-control CommonSelectBox TbxMarginBtm SelectMobile">
                  <option value="" disabled="true" selected>
                    Select Mobile No and Email
                  </option>
                  <option *ngFor="let data of SelectedMobileNumbers" [value]="data.OrignalValue">
                    {{ data.MaskValue }}
                  </option>
                </select>
                <label>Select Mobile No and Email</label>
                <div *ngIf="GetMobileFormSubmit && MobForm.MobileNo.errors" class="invalid-feedback">
                  <div *ngIf="MobForm.MobileNo.errors.required" class="Label14 OrangeClr">
                    Please Select Mobile No and Email.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center border-0 New_Modalfooter">
            <button type="button" class="CommonSubmitButton Btn_MfCentral w-100 m-0" (click)="OpenOTPModel()">
              Proceed
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal" id="MFCentralModalLoader" appDisabledRightClick data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-lg SmallWidth">
      <div class="modal-content AlertModalContentCls New_ContentCls">
        <div class="modal-body New_ModalBody text-center">
          <div class="d-flex align-items-center justify-content-center mt-5">
            <div class="mt-5">
              <img src="../../assets/images/JM/MF_Central/JM_MF_Central_Loader.svg" alt="" class="mt-4" />
              <div class="d-flex justify-content-center align-items-center mt-4 mb-5">
                <span><img src="../../assets/images/JM/MF_Central/Fetch_Loader.gif" width="30px" alt="" />
                </span>
                <span class="TrackText Fetching ml-2">Fetching MF details from MF Central</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Employee Login & Subbroker Login Open Client Selection Modal Started -->

  <div class="modal" id="EmpFilterModalMFCentral">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content AlertModalContentCls">
        <div class="modal-header AlertModalHeader">
          Search Client
          <button type="button" class="close close_new" data-dismiss="modal" (click)="GoToDashboard()">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-md-12">
              <app-clients-filter [isMultiSelect]="isMultiSelect"
                (FilterData_MFCentral)="ClientFilterData_MfCentral($event)" (FilterData)="ClientFilterData($event)"
                [DDLFilterType]="DDLFilterType" [DashboardUserId]="DashboardUserId">
              </app-clients-filter>
            </div>
          </div>
          <div class="SubmitMarginTop text-center">
            <button [disabled]="
                (UserType == 1 || UserType == 2) &&
                ClientPan == '' &&
                MobileNo == ''
              " class="CommonSubmitButton" (click)="onSubmitEmpForm()">
              Proceed
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ------------Lumpsum, Redeem, Factsheet----Redirect page Modal ------ -->

  <div class="modal" id="Menu_Popup" appDisabledRightClick data-backdrop="static" data-keyboard="false"
    style="background-color: #2828288f">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content AlertModalContentCls">
        <div class="modal-header AlertModalHeader">
          Options
          <button type="button" class="close close_new" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div>
            <div class="CheckAgree mb-1" [ngClass]="SchemeType == 'Normal' ? 'd-block' : 'd-none'">
              <label class="Cbx_container RadioBtn" (click)="RedirectPage('investMore')">
                <input type="radio" class="flterradio Rad1" name="RdbSchemeOption" value="investMore" id="investMore" />
                <span class="checkmark"></span>
                <label for="investMore" class="CursorPointer">Invest More</label>
              </label>
            </div>
            <div class="CheckAgree mb-1" [ngClass]="SchemeType == 'Normal' ? 'd-block' : 'd-none'">
              <label class="Cbx_container RadioBtn " (click)="RedirectPage('withdraw')">
                <input type="radio" class="flterradio Rad1" name="RdbSchemeOption" value="withdraw" id="withdraw" />
                <span class="checkmark"></span>
                <label for="withdraw" class="CursorPointer">Withdraw</label>
              </label>
            </div>
            <div class="CheckAgree mb-1">
              <label class="Cbx_container RadioBtn" (click)="RedirectPage('viewSchemeDetails')">
                <input type="radio" class="flterradio Rad1" name="RdbSchemeOption" value="viewSchemeDetails"
                  id="viewSchemeDetails" />
                <span class="checkmark"></span>
                <label for="viewSchemeDetails" class="CursorPointer">View Scheme Details</label>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>